module.exports = __webpack_public_path__ + "assets/img/1_552_big.a9083c6e.jpg";